import InfoOutlined from '@mui/icons-material/InfoOutlined';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { Box, IconButton, Tooltip } from '@mui/material';
import { KsefState } from 'pages/invoices/invoices.types';
import { useTranslation } from 'react-i18next';
import { KsefStatusChip } from '../../KsefStatusChip';

type Props = {
  state: KsefState | null;
  message?: string | null;
  qrLink?: string | null;
};

export const KsefStatusDetails = ({ state, message, qrLink }: Props) => {
  const { t } = useTranslation('invoice');

  if (!state && !qrLink) return null;

  const showReason =
    (state === 'REJECTED' || state === 'NEEDS_REVIEW') &&
    Boolean(message?.trim());

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <KsefStatusChip state={state} />
      </Box>
      {showReason && (
        <Tooltip title={message ?? ''} arrow>
          <IconButton
            size='small'
            aria-label={t(
              state === 'REJECTED' ? 'ksefRejectionReason' : 'ksefReviewReason',
            )}
            sx={{ p: 0.25, color: 'text.secondary' }}
          >
            <InfoOutlined sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      )}
      {qrLink && (
        <Tooltip title={t('openInKsef')} arrow>
          <IconButton
            component='a'
            href={qrLink}
            target='_blank'
            rel='noopener noreferrer'
            size='small'
            aria-label={t('openInKsef')}
            sx={{ p: 0.25, color: 'text.secondary' }}
          >
            <OpenInNew sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
